import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

import Consts from 'Framework/Consts';
import CountdownTimerFromUnix from 'Shared/Components/Forms/Timer/CountdownTimerFromUnix';
import { DataLayerHandler } from 'Shared/GoogleTagManager/DataLayerHandler';
import { useTranslationText } from 'Shared/Translation';
import { useUserManager } from 'Shared/User/Hooks/useUserManager';
import { IUser } from 'Shared/User/Models/IUser';

const RenewTokenModal: React.FunctionComponent = () => {
  const [translation] = useTranslationText();
  const { podSigninSilent, getUser, userManager } = useUserManager();

  const [show, setShow] = useState<boolean>(false);
  const [user, setUser] = useState<IUser | null>(null);
  const [userExpired, setUserExpired] = useState<boolean>(false);

  const ShowModal = () => setShow(true);
  const UnshowModal = () => setShow(false);
  const handleCountdownTimeFinished = () => {
    setUserExpired(true);
    DataLayerHandler.addCountDownVisibility('false');
  };

  const handleSigninSilent = () => {
    if (!userExpired) {
      DataLayerHandler.addCountDownVisibility('true');
      podSigninSilent().then(() => {
        UnshowModal();
        userManager.getUser().then(async (user: IUser | null) => {
          if (user !== null && !user.expired) setUser(user);
        });
      });
    }
  };

  useEffect(() => {
    userManager.events.addAccessTokenExpiring(() => {
      ShowModal();
      setUserExpired(false);
    });

    userManager.events.addAccessTokenExpired(() => {
      UnshowModal();
      userManager.getUser().then(async (user: IUser | null) => {
        if (user === null || user.expired) {
          DataLayerHandler.addGoToWepod(translation('FORWARD_USER_FROM_INSURANCE_TO_WEPOD'));

          localStorage.removeItem('token');
          await userManager.removeUser();
          await userManager.clearStaleState();

          const redirect =
            Consts.env.REACT_APP_WEPOD_URL == '' || Consts.env.REACT_APP_WEPOD_URL == undefined
              ? '/'
              : Consts.env.REACT_APP_WEPOD_URL;
          window.location.replace(redirect);
        } else setUser(user);
      });
    });

    userManager.events.addUserLoaded(() => {
      UnshowModal();
    });

    getUser().then((user) => {
      setUser(user);
    });
  }, []);

  return (
    <>
      <Modal show={show && user !== null && user.expires_at !== undefined} centered onHide={() => ShowModal()}>
        <Modal.Body>
          <div className='d-flex flex-column'>
            <span className='m-0 p-1 fw-bold'>
              {userExpired ? translation('EXITING_FROM_MODERN_INSURANCE') : translation('DO_YOU_CONTINUE_TO_WORK')}
            </span>
            {user && (
              <CountdownTimerFromUnix
                unixSecond={user.expires_at}
                handleCountdownTimeFinished={() => handleCountdownTimeFinished()}
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type='button'
            onClick={UnshowModal}
            className={`btn btn-link btn-outline-muted me-1 ${userExpired ? 'disabled' : ''}`}
          >
            {translation('CLOSE')}
          </button>
          <button
            id={'confitm_renew_token_button'}
            type='button'
            onClick={handleSigninSilent}
            className={`btn btn-success px-2 ${userExpired ? 'disabled' : ''}`}
          >
            {' '}
            {translation('OK')}{' '}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RenewTokenModal;
